import api from './api';

export interface Wedding {
  id: string;
  user_id: string;
  title: string;
  date: string | null;
  venue: string | null;
  currency: string;
  onboarding_completed: boolean;
  created_at: string;
  updated_at: string;
}

export const getWedding = () => api.get<Wedding>('/wedding');
export const updateWedding = (data: Partial<Wedding>) => api.put<Wedding>('/wedding', data);
